// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 934 ? "category-card" : chunkId) + "." + {"183":"974e8312","220":"5872aa95","408":"aeaecdcf","934":"878e4f96"}[chunkId] + ".chunk.css";
};